import LabelProvider from "core/components/label/LabelProvider";
import { Messages } from './../../common/Labels/Messages';
import { filters } from "common/Labels/Refine";

export default LabelProvider.create({

	DueDate: {
		k: "assignments.endDate",
		v: "Due Date"
	},

	AssignmentName: {
		k: "assignments.name",
        v: "Assignment Name"
	},

	AssignmentEmpty: {
		k: "assignments.empty.title",
		v: "No Assignments Found"
	},

	DescriptionEmpty: {
		k: "assignments.empty.description",
		v: ""
	},

	Submit: {
		k: "assignment.submit",
		v: "Submit"
	},

	...filters,

	...Messages,

	DueDateWarning: {
		k: "assignment.dueDate.warning",
        v: "Due in ${daysTilDue} Days!",
        argNames: ["daysTilDue"]
	}

});



// WEBPACK FOOTER //
// ./src/panels/assignments/Assignments.labels.ts